<template>
  <div class="outgoing-detail" v-if="detail != null">
    <Toast />

    <div class="card">
      <div class="card-header">
        <div class="header-content">
          <h5 class="card-title">Detail Mutasi</h5>
          <Button
            icon="pi pi-arrow-left"
            label="Kembali"
            class="p-button-text"
            @click="$router.go(-1)"
          />
        </div>
      </div>

      <div class="card-body">
        <div class="summary-grid">
          <div class="summary-item">
            <label class="summary-label">Tipe</label>
            <div class="summary-value">
              <span
                :class="['type-badge', `type-${getTypeSeverity(detail.type)}`]"
              >
                {{ detail.type }}
              </span>
            </div>
          </div>

          <div class="summary-item">
            <label class="summary-label">Nomor Bon</label>
            <div class="summary-value font-medium">{{ detail.doc_number }}</div>
          </div>

          <div class="summary-item">
            <label class="summary-label">Tanggal Bon</label>
            <div class="summary-value">
              {{ moment(detail.doc_date).format('DD-MM-YYYY') }}
            </div>
          </div>

          <div class="summary-item" v-if="this.$route.query.status != 0">
            <div class="action-buttons">
              <router-link
                :to="{
                  name: 'print-mutation-per-supplier',
                  query: {
                    doc_number: this.$route.query.doc_number,
                    warehouse_id: this.user.warehouse_id
                  }
                }"
                target="_blank"
              >
                <Button
                  label="Print Mutasi"
                  icon="pi pi-print"
                  class="p-button-success"
                />
              </router-link>
            </div>
          </div>
        </div>

        <div class="table-container">
          <table class="table table-responsive">
            <thead class="thead-light">
              <tr>
                <th scope="col" class="text-nowrap text-center">No</th>
                <th scope="col" class="text-nowrap">Kode Mutasi</th>
                <th scope="col" class="text-nowrap">Kode Barang</th>
                <th scope="col" class="text-nowrap">Nama Barang</th>
                <th scope="col" class="text-nowrap text-right">Stok Awal</th>
                <th scope="col" class="text-nowrap text-right">Harga Modal</th>
                <th scope="col" class="text-nowrap text-right">Harga Jual</th>
                <th scope="col" class="text-nowrap text-right">Diskon</th>
                <th
                  scope="col"
                  class="text-nowrap text-right"
                  v-for="(item, r) in outlets"
                  :key="r"
                >
                  {{ item.alias }}
                </th>
                <th scope="col" class="text-nowrap text-right">Total Jumlah</th>
                <th scope="col" class="text-nowrap text-right">Sisa Stock</th>
                <th scope="col" class="text-nowrap text-center">Aksi</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(an_item, k) in detail.items"
                :key="k"
                class="table-row"
              >
                <td class="text-nowrap text-center">{{ k + 1 }}</td>
                <td class="text-nowrap">
                  {{ an_item.purchase_order_mutation_code || '-' }}
                </td>
                <td class="text-nowrap">{{ an_item.item_code }}</td>
                <td class="text-nowrap">{{ an_item.item_name }}</td>
                <td class="text-right">
                  <template v-if="an_item.purchase_order_qty">
                    {{ parseInt(an_item.purchase_order_qty) | number }}
                  </template>
                  <template v-else>-</template>
                </td>
                <td class="text-right">
                  <template v-if="an_item.purchase_order_price">
                    {{ parseFloat(an_item.purchase_order_price) | currency }}
                  </template>
                  <template v-else>-</template>
                </td>

                <td
                  v-if="editable && edit_item.item_id == an_item.item_id"
                  class="text-right"
                >
                  <InputNumber
                    v-model="edit_item.price"
                    locale="id-ID"
                    min="0"
                    placeholder="0"
                    class="w-100"
                  />
                </td>
                <td v-else class="text-right">
                  {{ an_item.price | currency }}
                </td>

                <td class="text-right">{{ an_item.discount }}</td>

                <td v-for="(item, r) in outlets" :key="r" class="text-right">
                  <!-- regular mutation and others -->
                  <div v-if="editable && edit_item.item_id == an_item.item_id">
                    <InputText v-model="qty_edit[r].qty" class="w-100" />
                  </div>
                  <div v-else>
                    {{
                      getOutletQty(an_item, item.id) === 0
                        ? ''
                        : getOutletQty(an_item, item.id)
                    }}
                  </div>

                  <!-- special mutation -->
                  <div
                    v-if="
                      detail.type === 'SPECIAL_MUTATION' &&
                      editable &&
                      edit_item.item_id == an_item.item_id
                    "
                    class="mt-2"
                  >
                    <InputNumber
                      v-model="qty_edit[r].price"
                      locale="id-ID"
                      :min="0"
                      placeholder="0"
                      class="w-100"
                    />
                  </div>
                  <div
                    v-else-if="
                      detail.type === 'SPECIAL_MUTATION' &&
                      !editable &&
                      getOutletPrice(an_item, item.id) != 0
                    "
                    class="text-muted small"
                  >
                    {{ getOutletPrice(an_item, item.id) | currency }}
                  </div>
                </td>

                <td class="text-right">{{ an_item.total_qty | number }}</td>
                <td class="text-right">{{ an_item.stock | number }}</td>
                <td class="text-center">
                  <div
                    v-if="an_item.status == 0 && !editable"
                    class="d-flex justify-content-center"
                  >
                    <Button
                      type="button"
                      icon="pi pi-pencil"
                      class="p-button-rounded p-button-success p-mr-2"
                      @click="EditDialog(an_item)"
                    />
                    <Button
                      type="button"
                      icon="pi pi-trash"
                      class="p-button-rounded p-button-warning"
                      @click="confirmDelete(an_item)"
                    />
                  </div>
                  <div
                    v-if="editable && edit_item.item_id == an_item.item_id"
                    class="d-flex justify-content-center"
                  >
                    <Button
                      type="button"
                      icon="pi pi-check-circle"
                      class="p-button-rounded p-button-success p-mr-2"
                      @click="saveEdit(edit_item, qty_edit)"
                    />
                    <Button
                      type="button"
                      icon="pi pi-times-circle"
                      class="p-button-rounded p-button-danger"
                      @click="editable = false"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <Dialog
      :visible.sync="deleteDialog"
      :style="{ width: '450px' }"
      header="Confirm"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span v-if="mutasi">
          Apakah kamu yakin ingin menghapus
          <b>{{ mutasi.item_name }}</b
          >?
        </span>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          class="p-button-text"
          @click="deleteDialog = false"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          class="p-button-text"
          @click="deleteMutasi(mutasi.item_id)"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
var moment = require('moment')
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['user', 'isAuthenticated'])
  },

  watch: {
    user() {
      this.getAuthUser()
    }
  },
  data() {
    return {
      moment: moment,
      outlets: [],
      loading: true,
      products: null,
      expandedRows: [],
      detail: null,
      mutasi: {},
      deleteDialog: false,
      editable: false,
      edit_item: null,
      qty_edit: [],
      items: []
    }
  },
  async mounted() {
    try {
      await this.getListOutlets()
      await this.getWarehouseOutbounds()
      this.getAuthUser()
    } catch (error) {
      console.error('Error in mounted:', error)
      this.$toast.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Gagal memuat data. Silakan coba lagi.',
        life: 3000
      })
    }
  },

  methods: {
    getOutletQty(item, outletId) {
      if (!item.warehouse_outbounds) return 0
      const outbound = item.warehouse_outbounds.find(
        outbound => outbound && outbound.outlet_id === outletId
      )
      return outbound ? outbound.qty : 0
    },

    getOutletPrice(item, outletId) {
      if (!item.warehouse_outbounds) return 0
      const outbound = item.warehouse_outbounds.find(
        outbound => outbound && outbound.outlet_id === outletId
      )
      return outbound ? outbound.price : 0
    },

    confirmDelete(mutasi) {
      this.mutasi = mutasi
      this.deleteDialog = true
    },

    getAuthUser() {
      console.info(this.user)
    },

    async getListOutlets() {
      this.loading = true
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/outlets`
        )
        if (response.status === 200) {
          this.outlets = response.data.data.outlets
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Gagal mendapatkan data outlet',
            life: 3000
          })
        }
      } catch (error) {
        console.error('Error fetching outlets:', error)
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Gagal mendapatkan data outlet',
          life: 3000
        })
      } finally {
        this.loading = false
      }
    },

    async getWarehouseOutbounds() {
      if (!this.outlets.length) {
        console.warn('Outlets not loaded yet')
        return
      }

      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds/mutation?doc_number=${this.$route.query.doc_number}`
        )

        if (response.status === 200) {
          this.detail = response.data.data
          for (const item of this.detail.items) {
            if (!item.warehouse_outbounds) {
              item.warehouse_outbounds = []
            }

            // Map warehouse outbounds to outlets
            item.warehouse_outbounds = this.outlets.map(outlet => {
              const existingOutbound = item.warehouse_outbounds.find(
                outbound => outbound && outbound.outlet_id === outlet.id
              )

              return (
                existingOutbound || {
                  outlet_id: outlet.id,
                  price: 0,
                  qty: 0
                }
              )
            })
          }
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Gagal mendapatkan detail mutasi',
            life: 3000
          })
        }
      } catch (error) {
        console.error('Terjadi kesalahan saat mengambil detail mutasi:', error)
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Gagal mendapatkan detail mutasi',
          life: 3000
        })
      }
    },

    EditDialog(item) {
      this.editable = true
      this.edit_item = null
      this.qty_edit = []
      this.edit_item = item

      this.qty_edit = this.outlets.map(outlet => {
        const outbound = item.warehouse_outbounds.find(
          outbound => outbound && outbound.outlet_id === outlet.id
        )

        return {
          outlet_id: outlet.id,
          price: outbound ? outbound.price : item.price,
          qty: outbound ? outbound.qty : 0
        }
      })
    },

    saveEdit(data, data_edit) {
      const Qty = []

      for (let i = 0; i < data_edit.length; i++) {
        if (data_edit[i].qty !== 0) {
          Qty.push({
            outlet_id: data_edit[i].outlet_id,
            qty: parseInt(data_edit[i].qty),
            price: parseInt(data_edit[i].price)
          })
        }
      }

      this.items.push({
        item_id: data.item_id,
        price: parseInt(data.price),
        dicsount: parseInt(data.discount),
        warehouse_outbounds: Qty
      })

      this.PutSaveEdit()
    },

    async PutSaveEdit() {
      try {
        const response = await this.$http.put(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds/mutations?doc_number=${this.detail.doc_number}`,
          {
            items: this.items
          }
        )

        if (response.status === 200) {
          this.$toast.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Barang telah diubah',
            life: 3000
          })
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Terjadi kesalahan saat mengedit item',
            life: 3000
          })
        }

        await this.getWarehouseOutbounds()
        this.clear()
      } catch (error) {
        console.error('Terjadi kesalahan saat mengedit item:', error)
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Terjadi kesalahan saat mengedit item',
          life: 3000
        })
      }
    },

    clear() {
      this.edit_item = null
      this.qty_edit = []
      this.items = []
      this.editable = false
    },

    getTypeSeverity(type) {
      const types = {
        REGULAR_MUTATION: 'info',
        SPECIAL_MUTATION: 'warn',
        SALE_MUTATION: 'success',
        GIFT_MUTATION: 'info'
      }
      return types[type] || 'info'
    }
  }
}
</script>

<style lang="scss" scoped>
.outgoing-detail {
  .card {
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2),
      0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);

    .card-header {
      padding: 1.5rem;
      border-bottom: 1px solid #dee2e6;

      .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .card-title {
          margin: 0;
          font-size: 1.5rem;
          font-weight: 600;
          color: #495057;
        }
      }
    }

    .card-body {
      padding: 1.5rem;
    }
  }

  .summary-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1.5rem;
    margin-bottom: 2rem;
  }

  .summary-item {
    .summary-label {
      display: block;
      font-size: 0.875rem;
      color: #6c757d;
      margin-bottom: 0.5rem;
    }

    .summary-value {
      font-size: 1rem;
      color: #495057;
    }
  }

  .table-container {
    width: 100%;
    overflow-x: auto;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    background: #fff;
    margin-bottom: 1rem;

    // Custom scrollbar styling
    &::-webkit-scrollbar {
      height: 8px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 4px;

      &:hover {
        background: #555;
      }
    }
  }

  .table {
    margin-bottom: 0;
    font-family: inherit;

    thead {
      th {
        background-color: #f8f9fa;
        padding: 0.75rem;
        font-size: 0.875rem;
        font-weight: 600;
        white-space: nowrap;
        vertical-align: middle;
        font-family: inherit;
        text-align: center;
        border-bottom: 2px solid #dee2e6;
      }
    }

    tbody {
      tr {
        &:hover {
          background-color: rgba(0, 0, 0, 0.02);
        }

        td {
          padding: 0.75rem;
          font-size: 0.875rem;
          vertical-align: middle;
          font-family: inherit;
          border-bottom: 1px solid #dee2e6;
        }
      }
    }
  }

  .type-badge {
    display: inline-block;
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.2;

    &.type-info {
      background: #e3f2fd;
      color: #1976d2;
    }
    &.type-success {
      background: #e8f5e9;
      color: #2e7d32;
    }
    &.type-warn {
      background: #fff3e0;
      color: #e65100;
    }
    &.type-error {
      background: #ffebee;
      color: #c62828;
    }
  }

  // Utility classes
  .text-nowrap {
    white-space: nowrap;
  }

  .text-right {
    text-align: right;
  }

  .text-center {
    text-align: center;
  }

  .text-muted {
    color: #6c757d;
  }

  .small {
    font-size: 0.75rem;
  }

  .w-100 {
    width: 100%;
  }

  .mt-2 {
    margin-top: 0.5rem;
  }

  .d-flex {
    display: flex;
  }

  .justify-content-center {
    justify-content: center;
  }

  .font-medium {
    font-weight: 500;
  }

  // Input styling
  :deep(.p-inputtext),
  :deep(.p-inputnumber-input) {
    padding: 0.5rem;
    font-size: 0.875rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-family: inherit;

    &:focus {
      border-color: #80bdff;
      outline: 0;
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
  }

  // Button styling
  :deep(.p-button) {
    font-family: inherit;

    &.p-button-rounded {
      width: 2rem;
      height: 2rem;

      .p-button-icon {
        font-size: 0.875rem;
      }
    }
  }
}
</style>
